var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymptomHeartburn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H108C113.523 0 118 4.47715 118 10V114H0V10Z",
    fill: "#0BC3F4",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55C91 72.6733 76.6733 87 59 87C41.3267 87 27 72.6733 27 55C27 37.3267 41.3267 23 59 23C76.6733 23 91 37.3267 91 55Z",
    fill: "#77E1FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6593 52.5827L88.5231 52.7952L78.9456 87.0002H39.0543L29.4768 52.7952L27.3406 52.5827L28.2281 43.6039C28.5706 40.1377 30.9093 37.1914 34.2081 36.0727L49.3406 30.9414H68.6593L83.7906 36.0727C87.0906 37.1914 89.4293 40.1377 89.7718 43.6039L90.6593 52.5827Z",
    fill: "#76E4D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6593 52.5827L88.523 52.7952L78.9455 87.0002H58.9993V30.9414H68.6593L83.7905 36.0727C87.0905 37.1914 89.4293 40.1377 89.7718 43.6039L90.6593 52.5827Z",
    fill: "#50B2DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6164 53.9093L81.3974 54.6065L81.089 46.9238L77.342 47.0743L77.6164 53.9093Z",
    fill: "#3087BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3834 53.9093L36.6023 54.6065L36.9107 46.9238L40.6578 47.0743L40.3834 53.9093Z",
    fill: "#50B2DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4766 52.7939L30.2451 86.9989H39.0541L40.3831 53.9092L29.4766 52.7939Z",
    fill: "#FFC7B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6593 30.9412L58.9993 36.7575L49.3406 30.9412L51.3306 23H66.6856L68.6593 30.9412Z",
    fill: "#FFC7B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6593 30.9412L58.9993 36.7575V23H66.6855L68.6593 30.9412Z",
    fill: "#FAB096"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5231 52.7939L87.7547 86.9989H78.9456L77.6167 53.9092L88.5231 52.7939Z",
    fill: "#FAB096"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7043 55.7417L60.8643 58.5667L58.9993 58.673L57.1205 58.7792L56.8743 54.4367L58.8118 52.198L57.9243 49.5467L58.9993 49.1867L61.4805 48.3555L63.0468 53.0355L60.7043 55.7417Z",
    fill: "#335A8C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7043 55.7417L60.8643 58.5667L58.9993 58.673V49.1867L61.4805 48.3555L63.0468 53.0355L60.7043 55.7417Z",
    fill: "#27456D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3798 61.0451L63.2739 58.9435L65.7115 55.3411L68.609 54.7359L69.5112 52.0889L73.0608 53.2986L71.4688 57.9695L67.9658 58.7011L66.3798 61.0451Z",
    fill: "#27456D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6187 61.0451L50.0327 58.7011L46.5297 57.9695L44.9377 53.2986L48.4874 52.0889L49.3895 54.7359L52.287 55.3411L54.7246 58.9435L51.6187 61.0451Z",
    fill: "#335A8C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9993 79C63.4175 79 66.9993 75.4183 66.9993 71C66.9993 66.5817 63.4175 63 58.9993 63C54.581 63 50.9993 66.5817 50.9993 71C50.9993 75.4183 54.581 79 58.9993 79Z",
    fill: "#FF69AB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9993 71C66.9993 75.4187 63.418 79 58.9993 79V63C63.418 63 66.9993 66.5825 66.9993 71Z",
    fill: "#DE5B95"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1243 69.1689H60.8743V72.9189H57.1243V69.1689Z",
    fill: "#DE5B95"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9993 69.1689H60.8743V72.9189H58.9993V69.1689Z",
    fill: "#BD4A7A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomHeartburn);
export default __webpack_public_path__ + "static/media/symptom-Heartburn.2cb816ab3b104ce961cbabdb161e7fd6.svg";
export { ForwardRef as ReactComponent };